import { render } from "./checkmark-icon.vue?vue&type=template&id=e43e516e"
const script = {}

import exportComponent from "D:\\a\\1\\s\\Host\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__